import { resetForm } from "./applyFormData";
import { hideAndRemove } from "./changeObjectParams/helpers";
import { openCorrectSideMenu } from "./dynamicLoader";
import { setIntersectsObjects } from "./raycaster";
import { applyRoomLighting } from "./scene";
import { setCameraOnRoom } from "./setUpCamera";
import tippy from "tippy.js";
import "tippy.js/dist/tippy.css";
import { tippyIcons } from "./tippyIcons.js";
import { openModal } from "./modals.js";
import { resetCalculator, updateTotalBuildingPrice } from "./calculator.js";
import { menuTitlesMap } from "./vars/menuTitlesMap.js";
import { openAccordion } from "./accordions.js";
import { closeMenu } from "../helpers/closeMenu.js";

// Кнопка "Вернуться назад"
export const initBackBtnListeners = () => {
    document.querySelector(".back_btn")?.addEventListener("click", function () {
        let selector = this.dataset.toMenu;
        if (!selector) return;

        if (
            ["profile_type", "cabinet_type", "stulya_type", "verstaki_type"].includes(selector) &&
            servObj.isRedactorMode
        ) {
            openModal(
                "new_project_modal",
                // onConfirm
                async () => {
                    document.querySelector(".view2d3d").classList.remove("hide");
                    document.querySelector(".sizes").classList.remove("hide");

                    resetForm("form-object-params");

                    if (servObj.redactorModeObject) {
                        hideAndRemove(servObj.redactorModeObject);
                    }

                    servObj.isRedactorMode = false;
                    setCameraOnRoom();
                    applyRoomLighting();
                    document.getElementById("add_in_room_btn").parentNode.classList.add("hide");
                    document.querySelector(".animate-doors_btn_wrap").classList.add("hide");
                    initReadyComplectsLinks();
                    setIntersectsObjects([...servObj.building._all, ...servObj.building.walls, servObj.building.floor]);
                    await openCorrectSideMenu(selector, menuTitlesMap[servObj.targetPageKey]);
                    resetCalculator();
                    updateTotalBuildingPrice();

                    const { typeName } = servObj.redactorModeObject.userData.loadData;
                    const targetAccordion = document.querySelector(`.accordion.${typeName}`);
                    openAccordion(targetAccordion);
                },
                // onCancel
                () => {},
                "Вернуться назад",
            );
            return;
        }
        if (selector === "main_btns" && !servObj.isRedactorMode) {
            document.querySelector(".view2d3d").classList.remove("hide");
            document.querySelector(".sizes").classList.remove("hide");
            document.getElementById("add_in_room_btn").parentNode.classList.add("hide");
            document.querySelector(".animate-doors_btn_wrap").classList.add("hide");
            document.querySelector(".assist_btns").classList.add("hide");
            servObj.building.restoreColumnColor();
            servObj.building._missClick();
            servObj.active = null;

            if (servObj.isMobile) {
                closeMenu({ instant: true });
            }
        }
        openCorrectSideMenu(selector);
    });
};

// Инициализация слушателей для кнопок плюс и минус
export const initPlusMinusListeners = () => {
    const allWraps = document.querySelectorAll(".wrap_params");

    allWraps.forEach((wrap) => {
        const minusBtn = wrap.querySelector(".btn_minus");
        const plusBtn = wrap.querySelector(".btn_plus");
        const countInput = wrap.querySelector(".count_input");

        if (!countInput || !minusBtn || !plusBtn) return;

        const stepsAttr = countInput.getAttribute("data-steps");
        const steps = stepsAttr
            ? stepsAttr
                  .split(",")
                  .map(Number)
                  .sort((a, b) => a - b)
            : null;

        const updateState = () => {
            const current = Number(countInput.value);
            const maxValue = Number(countInput.getAttribute("max")) || 999;
            const minValue = Number(countInput.getAttribute("min")) || 0;

            if (steps) {
                const index = steps.indexOf(current);
                plusBtn.classList.toggle("disable", index >= steps.length - 1);
                minusBtn.classList.toggle("disable", index <= 0);
            } else {
                plusBtn.classList.toggle("disable", current >= maxValue);
                minusBtn.classList.toggle("disable", current <= minValue);
            }
        };

        const changeValue = (delta) => {
            let current = Number(countInput.value);
            const maxValue = Number(countInput.getAttribute("max")) || 999;
            const minValue = Number(countInput.getAttribute("min")) || 0;

            if (steps) {
                const index = steps.indexOf(current);
                const newIndex = index + delta;
                if (newIndex >= 0 && newIndex < steps.length) {
                    countInput.value = steps[newIndex];
                }
            } else {
                let newValue = current + delta;
                if (newValue > maxValue) newValue = maxValue;
                if (newValue < minValue) newValue = minValue;
                countInput.value = newValue;
            }

            countInput.dispatchEvent(new Event("change", { bubbles: true }));
        };

        minusBtn.addEventListener("pointerdown", () => changeValue(-1));
        plusBtn.addEventListener("pointerdown", () => changeValue(1));

        countInput.addEventListener("change", updateState);

        // Сохраняем updateState на input, чтобы можно было вызвать напрямую после изменения max/min
        countInput._updateState = updateState;

        updateState();
    });
};

const defaultMapLinks = [
    {
        link: "",
        name: "Комплект 1",
    },
    {
        link: "",
        name: "Комплект 2",
    },
    {
        link: "",
        name: "Комплект 3",
    },
    {
        link: "",
        name: "Комплект 4",
    },
    {
        link: "",
        name: "Комплект 5",
    },
];

/**
 * Инициализирует список ссылок в выпадающем меню "Готовые комплекты".
 *
 * Функция проверяет переданный массив ссылок, и если он корректен,
 * формирует HTML-ссылки и вставляет их в элемент с id "ready_complects".
 *
 * @param {Array<{link: string, name: string}>} [mapLinks=defaultMapLinks] - Массив объектов с полями:
 *      - link: URL ссылки,
 *      - name: отображаемое имя комплекта.
 */
export const initReadyComplectsLinks = (mapLinks = defaultMapLinks) => {
    if (!mapLinks || !Array.isArray(mapLinks) || mapLinks.length === 0) {
        console.warn("Нет доступных ссылок для готовых комплектов.");
        initReadyComplectsLinks(defaultMapLinks);
        return;
    }
    const readyComplectsDropup = document.getElementById("ready_complects");
    const readyComplectsDropupMenu = readyComplectsDropup.querySelector(".dropup__menu");
    readyComplectsDropupMenu.innerHTML = "";
    const linkItem = (name, path) => {
        const btn = document.createElement("button");
        btn.className = "dropup__item box_param";
        btn.textContent = name;
        btn.addEventListener("pointerdown", async () => {
            if (path.length <= 0) {
                console.warn(`Комплекту ${name.split(" ")[1]} не был передан путь к файлу`);
                return btn;
            }
            try {
                openModal("clear_scene_before_loading");
                const yesBtn = document.getElementById("load_complete_spec");
                yesBtn.dataset.path = path;
            } catch (err) {
                console.error("Не удалось загрузить комплект:", err);
            }
        });
        return btn;
    };
    mapLinks.forEach((link) => {
        const item = linkItem(link.name, link.link);
        readyComplectsDropupMenu.appendChild(item);
    });
};
export const toggleShowSizes = (boolean = null) => {
    const building = servObj.building;
    if (boolean === true) {
        // Если boolean true — устанавливаем состояния размеров на true (показываем размеры)
        servObj.isShowSizes = true;
        document.getElementById("show-hide-size").classList.add("active");
        if (servObj.is2dView) {
            building.showBuildingSize();
            building.hideHeightSize();
        } else {
            building.showBuildingSize();
            building.showHeightSize();
        }
    } else if (boolean === false) {
        // Если boolean false — устанавливаем состояния размеров на false (скрываем размеры)
        servObj.isShowSizes = false;
        document.getElementById("show-hide-size").classList.remove("active");
        building.hideBuildingSize();
        building.hideHeightSize();
    } else {
        // Если boolean не передан, переключаем состояния в противоположные
        servObj.isShowSizes = !servObj.isShowSizes;
        document.getElementById("show-hide-size").classList.toggle("active", servObj.isShowSizes);
        if (servObj.is2dView) {
            servObj.isShowSizes ? building.showBuildingSize() : building.hideBuildingSize();
            building.hideHeightSize();
        } else {
            servObj.isShowSizes ? building.showBuildingSize() : building.hideBuildingSize();
            servObj.isShowSizes ? building.showHeightSize() : building.hideHeightSize();
        }
    }
};
export const initToggleShowSizesListener = () => {
    document.getElementById("show-hide-size")?.addEventListener("pointerdown", (e) => {
        e.preventDefault();
        toggleShowSizes();
    });
};

// start multidrop
function updateMultidropLockState() {
    const hasOpen = document.querySelector(".multidrop.active");
    document.body.classList.toggle("multidrop-lock", !!hasOpen);
}
function closeAllMultidrops() {
    document.querySelectorAll(".multidrop.active").forEach((m) => m.classList.remove("active"));
    updateMultidropLockState();
    const wraps = document.querySelectorAll(".params_block_item.with_multidrop");
    wraps.forEach((wrap) => {
        if (wrap.querySelector(".title.text").classList.contains("disable")) {
            wrap.querySelector(".title.text").classList.remove("disable");
        }
    });
}
function handleMultidropToggle(e) {
    e.stopPropagation();
    const btn = e.currentTarget;
    const multidrop = btn.parentNode;
    const isActive = multidrop.classList.contains("active");
    multidrop.classList.toggle("active", !isActive);
    updateMultidropLockState();

    // Если меню закрывается, ищем и добавляем класс disabled на нужный .title.text
    // Ищем ближайший .params_block_item
    const paramsBlock = multidrop.closest(".params_block_item");
    // Ищем .title.text внутри paramsBlock
    const title = paramsBlock.querySelector(".title.text");
    title.classList.toggle("disable", !isActive);
}
document.addEventListener("pointerdown", (e) => {
    const isInsideMultidropMenu = e.target.closest(".multidrop__menu");
    const isMultiDropMenuBtn = e.target.classList.contains("multidrop__toggle");
    if (!isInsideMultidropMenu && !isMultiDropMenuBtn) {
        closeAllMultidrops();
    }
});
export const initMultidropMenuListeners = () => {
    // Обработчики кнопок открытия меню
    document.querySelectorAll(".multidrop__toggle").forEach((btn) => {
        btn.removeEventListener("click", handleMultidropToggle);
        btn.addEventListener("click", handleMultidropToggle);
    });

    // Обработка главных чекбоксов внутри with_multidrop
    document.querySelectorAll(".params_block_item.with_multidrop").forEach((block) => {
        const mainCheckbox = block.querySelector('.title input[type="checkbox"]');
        const multidrop = block.querySelector(".multidrop");
        if (!mainCheckbox || !multidrop) return;

        // Начальное состояние
        multidrop.classList.toggle("disable", !mainCheckbox.checked);

        // Удаляем старые слушатели и вешаем новый
        mainCheckbox.removeEventListener("change", handleMainCheckboxChange);
        mainCheckbox.addEventListener("change", handleMainCheckboxChange);
    });
};

// Общий обработчик переключения главного чекбокса
function handleMainCheckboxChange(e) {
    const checkbox = e.target;
    const block = checkbox.closest(".params_block_item.with_multidrop");
    const multidrop = block?.querySelector(".multidrop");
    if (!multidrop) return;
    const isChecked = checkbox.checked;
    multidrop.classList.toggle("disable", !isChecked);

    // Если выключили — сбрасываем все вложенные чекбоксы
    if (!isChecked) {
        const checkboxes = multidrop.querySelectorAll('input[type="checkbox"]');
        checkboxes.forEach((cb) => (cb.checked = false));
        checkboxes.forEach((cb) =>
            cb.dispatchEvent(
                new Event("change", {
                    bubbles: true,
                }),
            ),
        );
    }
}
// end multidrop

export const initDropup = () => {
    const dropupElements = document.querySelectorAll(".dropup");
    dropupElements.forEach((dropup) => {
        const button = dropup.querySelector(".dropup__btn");
        button.addEventListener("pointerdown", () => {
            dropup.classList.toggle("active");
        });
        document.addEventListener("pointerdown", (event) => {
            if (!dropup.contains(event.target)) {
                dropup.classList.remove("active");
            }
        });
    });
};

// start tooltips
export const initTooltips = (tooltipTexts = {}) => {
    // Сначала удалить все существующие тултипы на .info
    document.querySelectorAll(".info").forEach((el) => {
        if (el._tippy) {
            el._tippy.destroy();
        }
        const key = el.dataset.tooltipKey;
        const content = key && tooltipTexts[key] ? tooltipTexts[key] : "Информация";
        const instance = tippy(el, {
            content,
            touch: ["hold", 100],
            allowHTML: true,
            maxWidth: "350rem",
        });
        instance.popper.classList.add("tippy_popper");
    });

    // То же самое для .tooltip
    document.querySelectorAll(".tooltip").forEach((el) => {
        if (el._tippy) {
            el._tippy.destroy();
        }
        const btnId = el.id;
        const tooltipText = el.dataset.tooltipText || "Информация";
        const icon = tippyIcons[btnId];
        const instance = tippy(el, {
            content: `<span class="tooltip-text">${tooltipText}</span> <span class="${icon ? "tooltip-icon" : ""}">${icon || ""}</span>`,
            allowHTML: true,
            maxWidth: "",
            touch: ["hold", 100],
        });
        instance.popper.classList.add("tippy_popper");
    });
    document.querySelectorAll(".info_hook").forEach((el) => {
        if (el._tippy) {
            el._tippy.destroy();
        }
        const key = el.dataset.tooltipKey;
        const content = key && tooltipTexts[key] ? tooltipTexts[key] : "Информация";
        const instance = tippy(el, {
            content,
            touch: ["hold", 100],
            allowHTML: true,
            maxWidth: "350rem",
        });
        instance.popper.classList.add("tippy_popper_hook");
    });
};

// end tooltips

export const initOpenMenuBtnsListeners = () => {
    const openMenuBtns = document.querySelectorAll("[data-next-menu]");
    openMenuBtns.forEach((el) => {
        if (el.dataset.objectName) return;
        el.addEventListener("click", () => {
            let nextMenu = el.dataset.nextMenu;
            let menuTitle = el.dataset.menuTitle;

            if (el.dataset.targetKey) {
                servObj.targetPageKey = el.dataset.targetKey;
                menuTitle = menuTitlesMap[servObj.targetPageKey];
            }

            openCorrectSideMenu(nextMenu, menuTitle);
        });
    });
};

/**
 * @function initPhoneMask
 * @description
 * Инициализирует маску ввода для всех полей <input type="tel"> на странице.
 *
 * Маска формата: `+7 (___) ___-__-__`
 *
 * Функция:
 *  - Ограничивает ввод только цифрами;
 *  - Запрещает редактирование префикса `+7 (`;
 *  - Корректно обрабатывает Backspace, Delete, вставку и навигацию;
 *  - Позволяет очистить поле по клавише Escape (без закрытия модалки);
 *  - Автоматически добавляет маску при фокусе на пустое поле;
 *  - Работает с динамически добавленными элементами, если вызвать её повторно.
 *
 * Пример использования:
 * ```js
 * import { initPhoneMask } from './phone-mask.js';
 *
 * document.addEventListener('DOMContentLoaded', () => {
 *   initPhoneMask();
 * });
 * ```
 *
 * @example
 * // Если на странице появляется новая форма динамически:
 * initPhoneMask(); // просто вызвать снова
 *
 * @note
 * Повторный вызов не продублирует слушатели —
 * функция защищена флагом `data-mask-attached`.
 */
export const initPhoneMask = () => {
    // Находим все <input type="tel">
    const inputs = document.querySelectorAll('input[type="tel"]');
    if (!inputs.length) return;

    /** Формат маски */
    const MASK = "+7 (___) ___-__-__";
    /** Максимум цифр в номере */
    const MAX_DIGITS = 10;

    /** Индексы всех позиций '_' в маске (где разрешён ввод цифр) */
    const digitPosIndices = [];
    for (let i = 0; i < MASK.length; i++) if (MASK[i] === "_") digitPosIndices.push(i);
    /** Позиция, с которой начинается редактируемая часть */
    const firstEditablePos = digitPosIndices[0];

    /**
     * Форматирует "чистую" строку цифр в строку по маске
     * @param {string} raw - последовательность цифр
     * @returns {string} строка по шаблону маски
     */
    const formatFromRaw = (raw) => {
        let out = "";
        let di = 0;
        for (let i = 0; i < MASK.length; i++) {
            out += MASK[i] === "_" ? (di < raw.length ? raw[di++] : "_") : MASK[i];
        }
        return out;
    };

    /**
     * Подсчитывает количество цифр до позиции курсора
     * @param {number} pos - позиция курсора
     * @returns {number}
     */
    const digitsBeforeFromPos = (pos) => {
        let cnt = 0;
        for (let i = 0; i < digitPosIndices.length; i++) {
            if (digitPosIndices[i] < pos) cnt++;
            else break;
        }
        return cnt;
    };

    /**
     * Определяет позицию курсора по количеству введённых цифр
     * @param {number} digitsBefore - сколько цифр уже введено
     * @returns {number} индекс позиции курсора
     */
    const posFromDigitsBefore = (digitsBefore) => {
        if (digitsBefore <= 0) return firstEditablePos;
        const idx = Math.min(digitsBefore - 1, digitPosIndices.length - 1);
        return digitPosIndices[idx] + 1;
    };

    /**
     * Обновляет значение поля и позицию курсора
     * @param {HTMLInputElement} input
     * @param {string} raw - "чистые" цифры без форматирования
     * @param {number} digitsBeforeDesired - желаемое положение курсора (в цифрах)
     */
    const updateInputFromRaw = (input, raw, digitsBeforeDesired) => {
        raw = (raw || "").slice(0, MAX_DIGITS);
        const formatted = formatFromRaw(raw);
        input.dataset.raw = raw;
        input.dataset.isFormatting = "1";
        input.value = formatted;

        // Устанавливаем позицию курсора асинхронно (после перерисовки DOM)
        requestAnimationFrame(() => {
            const digitsBefore = Math.max(0, Math.min(digitsBeforeDesired || 0, raw.length));
            const pos = posFromDigitsBefore(digitsBefore);
            if (typeof input.setSelectionRange === "function") {
                input.setSelectionRange(pos, pos);
            }
            delete input.dataset.isFormatting;
        });
    };

    /**
     * Не позволяет установить курсор до первой редактируемой позиции
     * @param {HTMLInputElement} input
     */
    const ensureCaretNotBeforeFirstEditable = (input) => {
        const selStart = input.selectionStart ?? 0;
        if (selStart < firstEditablePos && typeof input.setSelectionRange === "function") {
            input.setSelectionRange(firstEditablePos, firstEditablePos);
        }
    };

    /**
     * Основной обработчик клавиатуры
     * Обрабатывает ввод, удаление, очистку и навигацию
     */
    const onKeyDown = (e) => {
        const input = e.target;
        if (input.dataset.isFormatting || e.isComposing || e.ctrlKey || e.metaKey) return;

        const key = e.key;
        const navKeys = ["ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown", "Home", "End", "Tab", "Enter"];
        if (navKeys.includes(key)) return;

        const raw = input.dataset.raw || "";
        const selStart = Math.max(input.selectionStart ?? 0, firstEditablePos);
        const selEnd = Math.max(input.selectionEnd ?? 0, firstEditablePos);
        const digitsBeforeStart = digitsBeforeFromPos(selStart);
        const digitsBeforeEnd = digitsBeforeFromPos(selEnd);
        const digitsInSelection = Math.max(0, digitsBeforeEnd - digitsBeforeStart);

        // === ESCAPE ===
        // Очищает поле, если в нём есть цифры. Если уже пусто — пропускает событие дальше (например, чтобы модалка закрылась)
        if (key === "Escape") {
            const hasDigits = (input.dataset.raw || "").length > 0;
            if (hasDigits) {
                e.preventDefault();
                e.stopPropagation();
                updateInputFromRaw(input, "", 0);
            }
            return;
        }

        // === DIGIT ===
        // Ввод цифр
        if (/^[0-9]$/.test(key)) {
            e.preventDefault();
            const available = MAX_DIGITS - (raw.length - digitsInSelection);
            if (available <= 0) return;
            const insertIndex = digitsBeforeStart;
            const newRaw = raw.slice(0, insertIndex) + key + raw.slice(insertIndex + digitsInSelection);
            updateInputFromRaw(input, newRaw, insertIndex + 1);
            return;
        }

        // === BACKSPACE ===
        // Удаляет цифру слева от курсора
        if (key === "Backspace") {
            e.preventDefault();
            if (digitsInSelection > 0) {
                const idx = digitsBeforeStart;
                const newRaw = raw.slice(0, idx) + raw.slice(idx + digitsInSelection);
                updateInputFromRaw(input, newRaw, idx);
            } else {
                const delIndex = digitsBeforeStart - 1;
                if (delIndex < 0) return;
                const newRaw = raw.slice(0, delIndex) + raw.slice(delIndex + 1);
                updateInputFromRaw(input, newRaw, delIndex);
            }
            return;
        }

        // === DELETE ===
        // Удаляет цифру справа от курсора
        if (key === "Delete") {
            e.preventDefault();
            if (digitsInSelection > 0) {
                const idx = digitsBeforeStart;
                const newRaw = raw.slice(0, idx) + raw.slice(idx + digitsInSelection);
                updateInputFromRaw(input, newRaw, idx);
            } else {
                const delIndex = digitsBeforeStart;
                if (delIndex >= raw.length) return;
                const newRaw = raw.slice(0, delIndex) + raw.slice(delIndex + 1);
                updateInputFromRaw(input, newRaw, delIndex);
            }
            return;
        }

        // Остальные символы (буквы, пробелы и т.п.) запрещены
        e.preventDefault();
    };

    /**
     * Обработка вставки (Ctrl+V)
     * Вставляются только цифры
     */
    const onPaste = (e) => {
        const input = e.target;
        if (input.dataset.isFormatting) return;
        e.preventDefault();

        const pasted = (e.clipboardData?.getData("text") || "").replace(/\D/g, "");
        if (!pasted) return;

        const raw = input.dataset.raw || "";
        const selStart = Math.max(input.selectionStart ?? 0, firstEditablePos);
        const selEnd = Math.max(input.selectionEnd ?? 0, firstEditablePos);
        const digitsBeforeStart = digitsBeforeFromPos(selStart);
        const digitsBeforeEnd = digitsBeforeFromPos(selEnd);
        const digitsInSelection = Math.max(0, digitsBeforeEnd - digitsBeforeStart);

        const available = MAX_DIGITS - (raw.length - digitsInSelection);
        const toInsert = pasted.slice(0, available);
        const newRaw = raw.slice(0, digitsBeforeStart) + toInsert + raw.slice(digitsBeforeStart + digitsInSelection);
        updateInputFromRaw(input, newRaw, digitsBeforeStart + toInsert.length);
    };

    /**
     * Восстанавливает формат, если пользователь вручную редактировал значение
     */
    const onInput = (e) => {
        const input = e.target;
        if (input.dataset.isFormatting) return delete input.dataset.isFormatting;
        const allDigits = (input.value || "").replace(/\D/g, "").slice(0, MAX_DIGITS);
        updateInputFromRaw(input, allDigits, allDigits.length);
    };

    /**
     * При фокусе форматирует поле, если оно пустое, и корректирует позицию курсора
     */
    const onFocus = (e) => {
        const input = e.target;
        const raw = (input.dataset.raw || "").replace(/\D/g, "").slice(0, MAX_DIGITS);
        updateInputFromRaw(input, raw, raw.length);
        setTimeout(() => ensureCaretNotBeforeFirstEditable(input), 0);
    };

    /** Коррекция позиции курсора при клике или отпускании мыши */
    const onMouseUpOrClick = (e) => {
        const input = e.target;
        setTimeout(() => ensureCaretNotBeforeFirstEditable(input), 0);
    };

    // === ИНИЦИАЛИЗАЦИЯ ===
    inputs.forEach((input) => {
        // Не инициализируем повторно
        if (input.dataset.maskAttached === "1") return;

        const allDigits = (input.value || "").replace(/\D/g, "").slice(0, MAX_DIGITS);
        input.dataset.raw = allDigits;
        input.value = formatFromRaw(allDigits);

        input.addEventListener("keydown", onKeyDown, false);
        input.addEventListener("paste", onPaste, false);
        input.addEventListener("input", onInput, false);
        input.addEventListener("focus", onFocus, false);
        input.addEventListener("mouseup", onMouseUpOrClick, false);
        input.addEventListener("click", onMouseUpOrClick, false);

        input.dataset.maskAttached = "1";
    });
};
